// extracted by mini-css-extract-plugin
export default {"title":"EditorialPage_title__CzivE","section":"EditorialPage_section__L6cml","list":"EditorialPage_list__38HTd","editorial__title":"EditorialPage_editorial__title__kYUVw"};